import { render, staticRenderFns } from "./LicenseTcDetails.vue?vue&type=template&id=57a4e78e"
import script from "./LicenseTcDetails.vue?vue&type=script&lang=ts"
export * from "./LicenseTcDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57a4e78e')) {
      api.createRecord('57a4e78e', component.options)
    } else {
      api.reload('57a4e78e', component.options)
    }
    module.hot.accept("./LicenseTcDetails.vue?vue&type=template&id=57a4e78e", function () {
      api.rerender('57a4e78e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/licenseTc/components/LicenseTcDetails.vue"
export default component.exports